import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './common/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-[#FFFC00]" data-id="element-253">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6" data-id="element-254">
        <div className="flex justify-between items-center py-4" data-id="element-255">
          {/* Logo */}
          <div className="flex items-center" data-id="element-256">
            <div className="flex items-center" data-id="element-257">
              <img src="https://cdn.magicpatterns.com/uploads/eJ1JrHt4bpZvdc7QodjVQQ/pasted-image.jpg" alt="Kraya Logo" className="h-48 w-48 object-cover rounded-3xl" data-id="element-258" />
              <span className="text-5xl text-[#1A1A1A] leading-none -ml-0.5" style={{
              fontFamily: "'Modak', cursive"
            }} data-id="element-259">
                Kraya
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-3" data-id="element-260">
            <a href="#how-it-works" className="inline-flex items-center justify-center font-bold rounded-full bg-[#1A1A1A] text-white px-6 py-2.5 text-base hover:bg-gray-800 transition-colors" data-id="element-261">
              How It Works
            </a>
            <a href="#merchants" className="inline-flex items-center justify-center font-bold rounded-full bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] px-6 py-2.5 text-base hover:bg-gray-50 transition-colors" data-id="element-262">
              For Merchants
            </a>
            <a href="#shoppers" className="inline-flex items-center justify-center font-bold rounded-full bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] px-6 py-2.5 text-base hover:bg-gray-50 transition-colors" data-id="element-263">
              For Shoppers
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-264">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#1A1A1A] hover:text-gray-600 focus:outline-none p-2" data-id="element-265">
              {isMenuOpen ? <XIcon className="h-8 w-8" data-id="element-266" /> : <MenuIcon className="h-8 w-8" data-id="element-267" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-268">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FFFC00] border-b-4 border-[#1A1A1A] overflow-hidden" data-id="element-269">
            <div className="px-4 pt-2 pb-6 space-y-3" data-id="element-270">
              <a href="#how-it-works" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-[#1A1A1A] text-white rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-271">
                How It Works
              </a>
              <a href="#merchants" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-white border-2 border-[#1A1A1A] rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-272">
                For Merchants
              </a>
              <a href="#shoppers" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-white border-2 border-[#1A1A1A] rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-273">
                For Shoppers
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}